import { useAppSelector, useAppDispatch } from '../../../store/hooks'
import { selectOpenModal } from '../../../store/ui/uiSelectors'
import { setOpenModal } from '../../../store/ui/uiSlice'
import WorkspaceSettingsModal from '../WorkspaceSettingsModal/WorkspaceSettingsModal'

const WorkspaceModalRouter = () => {
    const dispatch = useAppDispatch()
    const openModal = useAppSelector(selectOpenModal)

    const handleClose = () => {
        dispatch(setOpenModal(null))
    }

    // DEV: always show WorkspaceSettingsModal
    // return <WorkspaceSettingsModal onClose={handleClose} initialTab="general" />

    if (!openModal) return null

    switch (openModal.type) {
        case 'projectSettings':
            return <WorkspaceSettingsModal onClose={handleClose} initialTab={openModal.initialTab ?? 'general'} />
        default:
            return null
    }
}

export default WorkspaceModalRouter
